import { LinearProgress } from "@/components/progress";
import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Check, ChevronLeft, Plus, Trash, X } from "lucide-react";
import { ReactNode } from "react";

interface Props {
  title: ReactNode;
  addButtonLabel?: string;
  addButtonIcon?: ReactNode;
  acceptButtonLabel?: string;
  deleteButtonLabel?: string;
  cancelButtonLabel?: string;
  disableDelete?: boolean;
  disableAdd?: boolean;
  showButtons?: boolean;
  backButton?: boolean;
  aditionalButtons?: ReactNode;
  loading?: boolean;
  handleAdd?: () => void;
  handleAccept?: () => void;
  handleDelete?: () => void;
  handleCancel?: () => void;
  onBack?: () => void;
  breadcrumbComponent?: ReactNode;
  addButtonType?: "button" | "submit" | "reset";
}

export const SectionHeader = ({
  showButtons = true,
  title,
  addButtonLabel,
  addButtonIcon,
  acceptButtonLabel,
  deleteButtonLabel,
  cancelButtonLabel,
  backButton,
  aditionalButtons,
  disableDelete,
  disableAdd,
  loading,
  breadcrumbComponent,
  addButtonType,
  handleAdd,
  handleAccept,
  handleDelete,
  handleCancel,
  onBack,
}: Props) => {
  return (
    <>
      <Flex
        data-testid="section-header-main-box"
        width="100%"
        justifyContent="space-between"
        borderBottom={loading ? "" : `1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Flex alignItems="center" gap="36px">
          <Text
            fontWeight={700}
            fontSize="30px"
            data-testid="sectionheader-label"
          >
            {title}
          </Text>
          {breadcrumbComponent}
        </Flex>

        {showButtons && !loading ? (
          <Flex gap="20px">
            {addButtonLabel && (
              <Button
                paddingX="12px"
                height="32px"
                onClick={handleAdd}
                bgColor={AppColors.GREEN_PRIMARY}
                disabled={disableAdd}
                data-testid="sectionheader-add-button"
                type={addButtonType}
              >
                {addButtonIcon ?? <Plus />}
                <Text fontWeight={600} fontSize="14px">
                  {addButtonLabel}
                </Text>
              </Button>
            )}
            {cancelButtonLabel && (
              <Button
                paddingX="12px"
                height="32px"
                onClick={handleCancel}
                data-testid="sectionheader-cancel-button"
              >
                <X />
                <Text fontWeight={600} fontSize="14px">
                  {cancelButtonLabel}
                </Text>
              </Button>
            )}
            {aditionalButtons}
            {deleteButtonLabel && (
              <Button
                paddingX="12px"
                height="32px"
                onClick={handleDelete}
                disabled={disableDelete}
                data-testid="sectionheader-delete-button"
              >
                <Trash />
                <Text fontWeight={600} fontSize="14px">
                  {deleteButtonLabel}
                </Text>
              </Button>
            )}
            {acceptButtonLabel && (
              <Button
                paddingX="12px"
                height="32px"
                onClick={handleAccept}
                data-testid="sectionheader-accept-button"
              >
                <Check />
                <Text fontWeight={600} fontSize="14px">
                  {acceptButtonLabel}
                </Text>
              </Button>
            )}
          </Flex>
        ) : null}
        {backButton && (
          <Button
            paddingX="8px"
            onClick={onBack}
            h="32px"
            data-testid="section-header-back-button"
          >
            <Flex alignItems="center" gap="8px">
              <ChevronLeft /> Volver
            </Flex>
          </Button>
        )}
      </Flex>
      {loading && <LinearProgress />}
    </>
  );
};
